import { formName } from './constants'

export const translbl = `${formName}-lbl`
export const transCmd = `${formName}-cmd`
